// Which run screen a run belongs on: the train page, or its mode's own.
//
// THE FOLLOW'S TAP LINK WAS TRAIN-ONLY. A card about a route 19 tram handed the
// system `lateagain://train/<ref>/<stop>?route=6019`, the app opened the TRAIN
// page, and the train page asked PTV's train endpoint for a tram's ref and said
// "Couldn't reach PTV". The route id rides in the link already, and a line id
// says its mode on its own (`modeOfLine`: bands never overlap), so the screen
// is chosen from that — which fixes builds already in testers' hands, whose
// native side still writes the old URL, without a native build.
//
// PURE and registry-driven: a new mode gets its run screen here with no code.

import { modeOfLine, servedAdapterModes } from './modes.js';

/** The served adapter mode with a run screen that this id or word names, or null. */
export function runModeOf({ routeId = 0, mode = '' } = {}) {
  const served = servedAdapterModes().filter((m) => m.api);
  const word = String(mode ?? '').trim().toLowerCase();
  if (word) return served.find((m) => m.id === word) ?? null;
  const byLine = modeOfLine(routeId);
  return byLine && served.some((m) => m.id === byLine.id) ? byLine : null;
}

/**
 * The path of the run screen for a ride, or null for a train (the train page).
 * `{ runRef, stop, routeId, mode }` — `mode` wins when the link names one.
 */
export function runPath({ runRef, stop = 0, routeId = 0, mode = '' } = {}) {
  const ref = String(runRef ?? '').trim();
  const m = ref ? runModeOf({ routeId, mode }) : null;
  return m ? `/tabs/${m.id}-run/${encodeURIComponent(ref)}/${Number(stop) || 0}` : null;
}

/** Vue Router's `beforeEnter` for `/train/:runRef/:stopId`: a tram's ref is not a train's. */
export function trainRunRedirect(to) {
  const path = runPath({ runRef: to.params?.runRef, stop: to.params?.stopId, routeId: Number(to.query?.route) || 0 });
  return path ? { path, query: {}, replace: true } : true;
}
